import { isServer } from "shared/constants/isServer";
import styled from "styled-components";
import Florin from "./TrueFlorin.svg";
import { LayoutConst } from "core";
import { CurrencyType } from "@brg/api";
import { userCurrenciesState } from "shared/features/QueuePaymenrt/slices/userCurrenciesSlice";
import { CompositeCurrency, CurrencyPart, PaymentCurrency, UserPaymentCurrency } from "shared/features/QueuePaymenrt/constants/types";
import { FlowType } from "shared/features/QueuePaymenrt/constants/flowType";
import { FlorinIcon } from "shared/icons/FlorinIcon/FlorinIcon";

export const TrueFlorinIcon = styled.div<any>`
    background-image: url(${Florin});
    background-size: contain;
    background-repeat: no-repeat;
    filter: invert(${(p) => (p?.white ? 0 : p?.black ? 1 : 0.67)});
    height: ${(p) => (p.size ? p.size * 14 : 11)}px;
    width: ${(p) => (p.size ? p.size * 14 : 11)}px;
    margin: ${(p) => (p.margin !== undefined ? p.margin : '8px')};

    @media (max-width: ${LayoutConst.screen.s}px) {
        height: ${(p) => (p.mobileSize ? p.mobileSize * 14 : 12)}px;
        width: ${(p) => (p.mobileSize ? p.mobileSize * 14 : 12)}px;
        margin: 0;
    }
`;
interface GetCurrentCurrency {
    currency: any
    userBalance: userCurrenciesState
    formatValue: any
    context?: string
}

interface GetCurrencyIcon {
    currencyType: CurrencyType
    isBalance?: boolean
    isWhite?: boolean
}

export const getCurrencyType = (currency?: PaymentCurrency): CurrencyType => {
    if (!currency) {
        return CurrencyType.RealMoney
    }
    return isCompositeCurrency(currency) ? getSortedCompositeCurrencyParts(currency)[0].currencyType : currency?.currencyType;
}

export const getCountryCurrencyName = (countryName: string): string => {
    return countryName ? countryName.split(" ").map((word: string) => word[0].toUpperCase()).join("") + "$" : ''
}

// deprecated, use searchCurrencyItem
export const getCurrentCurrency = (props: GetCurrentCurrency) => {
    const { currency, userBalance, formatValue, context } = props
    console.log('user balance !!!', userBalance?.currencies, currency)
    switch (currency?.currencyType) {
        case CurrencyType.PlayMoney:
            if (context === 'zeland') {
                const balanceList: any = userBalance?.currencies
                const balance = balanceList?.find((currencyItem: any) => {
                    return (currencyItem.countryId === currency.countryId && currencyItem.currencyType === 0)
                })?.amount
                return formatValue(balance, CurrencyType.PlayMoney)
            }
            return formatValue(userBalance?.PlayMoney, CurrencyType.PlayMoney)
        case CurrencyType.RealMoney:
            return formatValue(userBalance?.RealMoney, CurrencyType.RealMoney)
        default:
            return 0
    }
}

export const getCurrencyIcon = (props: GetCurrencyIcon) => {
    if (isServer) {
        return
    }
    const { currencyType, isBalance, isWhite = true } = props 
    const florinSize = isBalance ? 20 / 15 : 30 / 15
    const florinMobileSize = isBalance ? 18 / 15 : 24 / 15
    const florinMargin = isBalance ? '0px 5px' : '0px'
    const florinMarginLeft = isBalance ? '5px' : '8px'
    switch (currencyType) {
        case CurrencyType.PlayMoney:
            return <TrueFlorinIcon
                    margin={florinMargin}
                    mobileSize={florinMobileSize} 
                    size={florinSize}
                    style={{ marginLeft: florinMarginLeft }} 
                    white={isWhite}
                />
        case CurrencyType.RealMoney:
            return <FlorinIcon
                    margin={florinMargin}
                    mobileSize={florinMobileSize} 
                    size={florinSize} 
                    style={{ marginLeft: florinMarginLeft }} 
                    white={isWhite}
                />
        case CurrencyType.RUB:
            return '₽'
        default:
            return undefined
    }
}

interface CurrencyItemSearchConditions {
    currencyType?: CurrencyType
    countryId?: string | null
}

export enum CurrencyAccountType {
    payment = 'payment',
    user = 'user'
}

interface SearchPaymentCurrencyItem {
    accountType: CurrencyAccountType.payment
    currencies: PaymentCurrency[]
    search: CurrencyItemSearchConditions
}

interface SearchUserCurrencyItem {
    accountType: CurrencyAccountType.user
    currencies: UserPaymentCurrency[]
    search: CurrencyItemSearchConditions
}

type SearchCurrencyItemProps = SearchPaymentCurrencyItem | SearchUserCurrencyItem


// TODO: сделать нормальный type narrowing для валют
export const searchCurrencyItem = (props: SearchCurrencyItemProps): SearchCurrencyItemProps["currencies"][number] | undefined => {
    const { currencies, search, accountType } = props

    if(!(currencies?.length && search)) {
        return 
    }

    // поиск валют пользователя
    if (accountType === CurrencyAccountType.user) {
        return currencies.find((currencyItem) => {
            if (search.countryId) {
                return currencyItem?.countryId === search?.countryId
            }
    
            return currencyItem?.currencyType === search.currencyType
        })
    }

    // поиск валют для оплаты
    return currencies.find((currencyItem) => {
        if (isCompositeCurrency(currencyItem)) {
            return getSortedCompositeCurrencyParts(currencyItem)[0].currencyType === search.currencyType
        }

        if (search.countryId) {
            return currencyItem?.countryId === search?.countryId
        }

        return currencyItem?.currencyType === search.currencyType
    })
}

export const storeAdditionalOrderInfo = (flowType: FlowType, info: any) => { 
    if (isServer) {
        return
    }
    if (!info) {
        return
    }

    // localstorage cleanup
    const itemsToDelete: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i)?.startsWith(`${flowType}_`) &&
            localStorage[i]?.originalCardId === info.originalCardId) {            
            itemsToDelete.push(localStorage.key(i) as string)
        }
    }
    itemsToDelete.forEach((item) => localStorage.removeItem(item))

    // localstorage save
    localStorage.setItem(`${flowType}_${info.res?.id}`, JSON.stringify(info));
}

export const isCompositeCurrency = (currency: PaymentCurrency): currency is CompositeCurrency => {
    return (currency as CompositeCurrency).parts !== undefined;
}

// сортировка частей сложной цены по убыванию. Первый элемент - главная часть цены
export const getSortedCompositeCurrencyParts = (currency: CompositeCurrency): CurrencyPart[] => {
    const partsArray = [...currency.parts]
    return partsArray.sort((a, b) => {
        const firstAmount = a.currencyType || 0
        const secondAmount = b.currencyType || 0
        return  firstAmount - secondAmount
    })
}

export enum CurrencyTheme {
    light = 'light',
    dark = 'dark'
}

export const getCurrencyTheme = (currenciesLength: number, currencyPosition: number): CurrencyTheme => {
    if (currenciesLength > 1) {
        return (currencyPosition + 1) % 2 === 0 ? CurrencyTheme.dark : CurrencyTheme.light
    }
    return CurrencyTheme.dark
}

export const getFormattedCurrency = (props: any) => {
    const { currency, formatValue, currencyType } = props
    const part = currency && currency.parts?.find((part: CurrencyPart) => part.currencyType === currencyType)
    const v = (part?.amount !== undefined) && formatValue && (formatValue(part.amount) || '0')
    return { part, v }
}import { isServer } from "shared/constants/isServer";
import styled from "styled-components";
import Florin from "./TrueFlorin.svg";
import { LayoutConst } from "core";
import { CurrencyType } from "@brg/api";
import { userCurrenciesState } from "shared/features/QueuePaymenrt/slices/userCurrenciesSlice";
import { CompositeCurrency, CurrencyPart, PaymentCurrency, UserPaymentCurrency } from "shared/features/QueuePaymenrt/constants/types";
import { FlowType } from "shared/features/QueuePaymenrt/constants/flowType";
import { FlorinIcon } from "shared/icons/FlorinIcon/FlorinIcon";

export const TrueFlorinIcon = styled.div<any>`
    background-image: url(${Florin});
    background-size: contain;
    background-repeat: no-repeat;
    filter: invert(${(p) => (p?.white ? 0 : p?.black ? 1 : 0.67)});
    height: ${(p) => (p.size ? p.size * 14 : 11)}px;
    width: ${(p) => (p.size ? p.size * 14 : 11)}px;
    margin: ${(p) => (p.margin !== undefined ? p.margin : '8px')};

    @media (max-width: ${LayoutConst.screen.s}px) {
        height: ${(p) => (p.mobileSize ? p.mobileSize * 14 : 12)}px;
        width: ${(p) => (p.mobileSize ? p.mobileSize * 14 : 12)}px;
        margin: 0;
    }
`;
interface GetCurrentCurrency {
    currency: any
    userBalance: userCurrenciesState
    formatValue: any
    context?: string
}

interface GetCurrencyIcon {
    currencyType: CurrencyType
    isBalance?: boolean
    isWhite?: boolean
}

export const getCurrencyType = (currency?: PaymentCurrency): CurrencyType => {
    if (!currency) {
        return CurrencyType.RealMoney
    }
    return isCompositeCurrency(currency) ? getSortedCompositeCurrencyParts(currency)[0].currencyType : currency?.currencyType;
}

export const getCountryCurrencyName = (countryName: string): string => {
    return countryName ? countryName.split(" ").map((word: string) => word[0].toUpperCase()).join("") + "$" : ''
}

// deprecated, use searchCurrencyItem
export const getCurrentCurrency = (props: GetCurrentCurrency) => {
    const { currency, userBalance, formatValue, context } = props
    console.log('user balance !!!', userBalance?.currencies, currency)
    switch (currency?.currencyType) {
        case CurrencyType.PlayMoney:
            if (context === 'zeland') {
                const balanceList: any = userBalance?.currencies
                const balance = balanceList?.find((currencyItem: any) => {
                    return (currencyItem.countryId === currency.countryId && currencyItem.currencyType === 0)
                })?.amount
                return formatValue(balance, CurrencyType.PlayMoney)
            }
            return formatValue(userBalance?.PlayMoney, CurrencyType.PlayMoney)
        case CurrencyType.RealMoney:
            return formatValue(userBalance?.RealMoney, CurrencyType.RealMoney)
        default:
            return 0
    }
}

export const getCurrencyIcon = (props: GetCurrencyIcon) => {
    if (isServer) {
        return
    }
    const { currencyType, isBalance, isWhite = true } = props 
    const florinSize = isBalance ? 20 / 15 : 30 / 15
    const florinMobileSize = isBalance ? 18 / 15 : 24 / 15
    const florinMargin = isBalance ? '0px 5px' : '0px'
    const florinMarginLeft = isBalance ? '5px' : '8px'
    switch (currencyType) {
        case CurrencyType.PlayMoney:
            return <TrueFlorinIcon
                    margin={florinMargin}
                    mobileSize={florinMobileSize} 
                    size={florinSize}
                    style={{ marginLeft: florinMarginLeft }} 
                    white={isWhite}
                />
        case CurrencyType.RealMoney:
            return <FlorinIcon
                    margin={florinMargin}
                    mobileSize={florinMobileSize} 
                    size={florinSize} 
                    style={{ marginLeft: florinMarginLeft }} 
                    white={isWhite}
                />
        case CurrencyType.RUB:
            return '₽'
        default:
            return undefined
    }
}

interface CurrencyItemSearchConditions {
    currencyType?: CurrencyType
    countryId?: string | null
}

export enum CurrencyAccountType {
    payment = 'payment',
    user = 'user'
}

interface SearchPaymentCurrencyItem {
    accountType: CurrencyAccountType.payment
    currencies: PaymentCurrency[]
    search: CurrencyItemSearchConditions
}

interface SearchUserCurrencyItem {
    accountType: CurrencyAccountType.user
    currencies: UserPaymentCurrency[]
    search: CurrencyItemSearchConditions
}

type SearchCurrencyItemProps = SearchPaymentCurrencyItem | SearchUserCurrencyItem


// TODO: сделать нормальный type narrowing для валют
export const searchCurrencyItem = (props: SearchCurrencyItemProps): SearchCurrencyItemProps["currencies"][number] | undefined => {
    const { currencies, search, accountType } = props

    if(!(currencies?.length && search)) {
        return 
    }

    // поиск валют пользователя
    if (accountType === CurrencyAccountType.user) {
        return currencies.find((currencyItem) => {
            if (search.countryId) {
                return currencyItem?.countryId === search?.countryId
            }
    
            return currencyItem?.currencyType === search.currencyType
        })
    }

    // поиск валют для оплаты
    return currencies.find((currencyItem) => {
        if (isCompositeCurrency(currencyItem)) {
            return getSortedCompositeCurrencyParts(currencyItem)[0].currencyType === search.currencyType
        }

        if (search.countryId) {
            return currencyItem?.countryId === search?.countryId
        }

        return currencyItem?.currencyType === search.currencyType
    })
}

export const storeAdditionalOrderInfo = (flowType: FlowType, info: any) => { 
    if (isServer) {
        return
    }
    if (!info) {
        return
    }

    // localstorage cleanup
    const itemsToDelete: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i)?.startsWith(`${flowType}_`) &&
            localStorage[i]?.originalCardId === info.originalCardId) {            
            itemsToDelete.push(localStorage.key(i) as string)
        }
    }
    itemsToDelete.forEach((item) => localStorage.removeItem(item))

    // localstorage save
    localStorage.setItem(`${flowType}_${info.res?.id}`, JSON.stringify(info));
}

export const isCompositeCurrency = (currency: PaymentCurrency): currency is CompositeCurrency => {
    return (currency as CompositeCurrency).parts !== undefined;
}

// сортировка частей сложной цены по убыванию. Первый элемент - главная часть цены
export const getSortedCompositeCurrencyParts = (currency: CompositeCurrency): CurrencyPart[] => {
    const partsArray = [...currency.parts]
    return partsArray.sort((a, b) => {
        const firstAmount = a.currencyType || 0
        const secondAmount = b.currencyType || 0
        return  firstAmount - secondAmount
    })
}

export enum CurrencyTheme {
    light = 'light',
    dark = 'dark'
}

export const getCurrencyTheme = (currenciesLength: number, currencyPosition: number): CurrencyTheme => {
    if (currenciesLength > 1) {
        return (currencyPosition + 1) % 2 === 0 ? CurrencyTheme.dark : CurrencyTheme.light
    }
    return CurrencyTheme.dark
}

export const getFormattedCurrency = (props: any) => {
    const { currency, formatValue, currencyType } = props
    const part = currency && currency.parts?.find((part: CurrencyPart) => part.currencyType === currencyType)
    const v = (part?.amount !== undefined) && formatValue && (formatValue(part.amount) || '0')
    return { part, v }
}